import { Box } from '@mui/material'
import styled from '@emotion/styled'

import { emotionTheme } from '@styles/theme'

export const Container = styled(Box)`
  width: 100%;
  height: 100%;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  padding: 10px 24px;
  display: flex;
  align-items: center;

  color: ${emotionTheme.colors.secondary};
  background: red;
`

export const Footerlabel = styled(Box)`
  height: 48px;
  padding-left: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${emotionTheme.colors.secondary};
`

export const FooterValue = styled(Box)`
  font-weight: 700;
  color: ${emotionTheme.colors.secondary};
`
